import React, { useEffect, useState } from 'react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// styles
import styles from './index.module.scss'

// call apis
import dashboardAPI from 'apis/dashboard'
import UpcomingEventCard from 'components/Card/UpcomingEventCard'

const UpcomingEventSection = props => {
  const { hideSection } = props
  const [upcomingEventList, setUpcomingEventList] = useState([])

  useEffect(() => {
    const fetchUpcomingEvent = async () => {
      try {
        const response = await dashboardAPI.getFeedData('upcoming-event')
        if (response && Array.isArray(response.cards)) {
          if (response.cards === 0) hideSection()
          else setUpcomingEventList(response.cards.slice(0, 4))
        } else {
          hideSection()
        }
      } catch (error) {
        console.error('Error fetching upcoming event data:', error)
        hideSection()
      } finally {
      }
    }

    fetchUpcomingEvent()
  }, [hideSection])

  return (
    <section className={styles.container}>
      <div className="w-full g-container flex justify-between items-center">
        <div className={styles.headerContent}>
          <div className={styles.title}>Upcoming Events</div>
        </div>
        <div className={styles.viewAll}>View All</div>
      </div>
      <div className={`w-full g-container lg:flex gap-[20px] hidden mt-[25px]`}>
        {upcomingEventList.map((item, index) => (
          <div key={index} className="w-full max-w-[380px]">
            <UpcomingEventCard data={item} />
          </div>
        ))}
      </div>
      {/* Mobile */}
      <div className="w-full flex gap-[15px] overflow-x-auto lg:hidden mt-[15px] z-10 px-[16px]">
        {upcomingEventList.map((item, index) => (
          <div key={index} className="w-full min-w-[300px] max-w-[300px]">
            <UpcomingEventCard data={item} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default UpcomingEventSection
